/** Suma pesos por grupo de contenedor (misma lógica que packing list PDF). */

function safe(s) {
  return s == null ? '' : String(s);
}

function grossStr(r) {
  return r.peso != null ? String(r.peso) : '';
}

function netStr(r) {
  const n = r.peso_neto != null && r.peso_neto !== '' ? Number(r.peso_neto) : null;
  if (n != null && !Number.isNaN(n)) return String(n);
  return r.peso != null ? String(r.peso) : '';
}

function sameMergeGroup(a, b) {
  const ca = safe(a.container_celda).trim() || safe(a._container_excel).trim();
  const cb = safe(b.container_celda).trim() || safe(b._container_excel).trim();
  if (!ca || ca !== cb) return false;
  return grossStr(a) === grossStr(b) && netStr(a) === netStr(b);
}

export function sumPesoGrossByMergeGroups(lineas) {
  let s = 0;
  let i = 0;
  while (i < lineas.length) {
    let j = i + 1;
    while (j < lineas.length && sameMergeGroup(lineas[j - 1], lineas[j])) {
      j += 1;
    }
    s += Number(lineas[i].peso) || 0;
    i = j;
  }
  return s;
}

export function sumPesoNetByMergeGroups(lineas) {
  let s = 0;
  let i = 0;
  while (i < lineas.length) {
    let j = i + 1;
    while (j < lineas.length && sameMergeGroup(lineas[j - 1], lineas[j])) {
      j += 1;
    }
    const n =
      lineas[i].peso_neto != null && lineas[i].peso_neto !== ''
        ? Number(lineas[i].peso_neto)
        : Number(lineas[i].peso) || 0;
    s += n;
    i = j;
  }
  return s;
}
